import { render, staticRenderFns } from "./PriceListForm.vue?vue&type=template&id=7e05b7d4"
import script from "./PriceListForm.vue?vue&type=script&lang=ts"
export * from "./PriceListForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports